import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';

const ChatUserSearchPageContent = lazy(() => import('./SearchPageContent'));

export const ChatUserSearchPage = wrapNavigatorScreen(
  ChatUserSearchPageContent,
  {
    headerShown: false,
    cardStyle: {
      backgroundColor: '#000',
    },
  },
);
